//NOTE: see note at end of file
export const rawWages = [
  { Date: '1/1/10', 'Job Stayer': 0.026, 'Job Switcher': 0.02, Overall: 0.025 },
  {
    Date: '2/1/10',
    'Job Stayer': 0.026,
    'Job Switcher': 0.019,
    Overall: 0.024
  },
  {
    Date: '3/1/10',
    'Job Stayer': 0.024,
    'Job Switcher': 0.018,
    Overall: 0.023
  },
  {
    Date: '4/1/10',
    'Job Stayer': 0.023,
    'Job Switcher': 0.017,
    Overall: 0.021
  },
  { Date: '5/1/10', 'Job Stayer': 0.021, 'Job Switcher': 0.016, Overall: 0.02 },
  {
    Date: '6/1/10',
    'Job Stayer': 0.021,
    'Job Switcher': 0.017,
    Overall: 0.019
  },
  { Date: '7/1/10', 'Job Stayer': 0.02, 'Job Switcher': 0.016, Overall: 0.018 },
  {
    Date: '8/1/10',
    'Job Stayer': 0.019,
    'Job Switcher': 0.017,
    Overall: 0.018
  },
  {
    Date: '9/1/10',
    'Job Stayer': 0.019,
    'Job Switcher': 0.017,
    Overall: 0.018
  },
  {
    Date: '10/1/10',
    'Job Stayer': 0.017,
    'Job Switcher': 0.017,
    Overall: 0.017
  },
  {
    Date: '11/1/10',
    'Job Stayer': 0.017,
    'Job Switcher': 0.018,
    Overall: 0.017
  },
  {
    Date: '12/1/10',
    'Job Stayer': 0.017,
    'Job Switcher': 0.019,
    Overall: 0.018
  },
  { Date: '1/1/11', 'Job Stayer': 0.016, 'Job Switcher': 0.02, Overall: 0.018 },
  { Date: '2/1/11', 'Job Stayer': 0.016, 'Job Switcher': 0.02, Overall: 0.018 },
  { Date: '3/1/11', 'Job Stayer': 0.016, 'Job Switcher': 0.02, Overall: 0.018 },
  {
    Date: '4/1/11',
    'Job Stayer': 0.016,
    'Job Switcher': 0.021,
    Overall: 0.018
  },
  {
    Date: '5/1/11',
    'Job Stayer': 0.017,
    'Job Switcher': 0.022,
    Overall: 0.019
  },
  {
    Date: '6/1/11',
    'Job Stayer': 0.017,
    'Job Switcher': 0.022,
    Overall: 0.019
  },
  {
    Date: '7/1/11',
    'Job Stayer': 0.017,
    'Job Switcher': 0.023,
    Overall: 0.019
  },
  { Date: '8/1/11', 'Job Stayer': 0.017, 'Job Switcher': 0.023, Overall: 0.02 },
  {
    Date: '9/1/11',
    'Job Stayer': 0.017,
    'Job Switcher': 0.022,
    Overall: 0.019
  },
  {
    Date: '10/1/11',
    'Job Stayer': 0.018,
    'Job Switcher': 0.023,
    Overall: 0.02
  },
  {
    Date: '11/1/11',
    'Job Stayer': 0.018,
    'Job Switcher': 0.023,
    Overall: 0.02
  },
  {
    Date: '12/1/11',
    'Job Stayer': 0.018,
    'Job Switcher': 0.022,
    Overall: 0.02
  },
  { Date: '1/1/12', 'Job Stayer': 0.019, 'Job Switcher': 0.022, Overall: 0.02 },
  { Date: '2/1/12', 'Job Stayer': 0.019, 'Job Switcher': 0.023, Overall: 0.02 },
  { Date: '3/1/12', 'Job Stayer': 0.019, 'Job Switcher': 0.023, Overall: 0.02 },
  {
    Date: '4/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.024,
    Overall: 0.021
  },
  {
    Date: '5/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.022,
    Overall: 0.021
  },
  {
    Date: '6/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.023,
    Overall: 0.021
  },
  {
    Date: '7/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.023,
    Overall: 0.021
  },
  { Date: '8/1/12', 'Job Stayer': 0.018, 'Job Switcher': 0.023, Overall: 0.02 },
  {
    Date: '9/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.024,
    Overall: 0.021
  },
  {
    Date: '10/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.023,
    Overall: 0.021
  },
  {
    Date: '11/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.024,
    Overall: 0.021
  },
  {
    Date: '12/1/12',
    'Job Stayer': 0.019,
    'Job Switcher': 0.026,
    Overall: 0.022
  },
  { Date: '1/1/13', 'Job Stayer': 0.02, 'Job Switcher': 0.025, Overall: 0.022 },
  { Date: '2/1/13', 'Job Stayer': 0.02, 'Job Switcher': 0.025, Overall: 0.022 },
  { Date: '3/1/13', 'Job Stayer': 0.02, 'Job Switcher': 0.026, Overall: 0.022 },
  {
    Date: '4/1/13',
    'Job Stayer': 0.019,
    'Job Switcher': 0.026,
    Overall: 0.022
  },
  {
    Date: '5/1/13',
    'Job Stayer': 0.019,
    'Job Switcher': 0.027,
    Overall: 0.022
  },
  {
    Date: '6/1/13',
    'Job Stayer': 0.019,
    'Job Switcher': 0.027,
    Overall: 0.022
  },
  {
    Date: '7/1/13',
    'Job Stayer': 0.019,
    'Job Switcher': 0.027,
    Overall: 0.022
  },
  { Date: '8/1/13', 'Job Stayer': 0.02, 'Job Switcher': 0.027, Overall: 0.023 },
  {
    Date: '9/1/13',
    'Job Stayer': 0.019,
    'Job Switcher': 0.027,
    Overall: 0.022
  },
  {
    Date: '10/1/13',
    'Job Stayer': 0.02,
    'Job Switcher': 0.027,
    Overall: 0.023
  },
  {
    Date: '11/1/13',
    'Job Stayer': 0.02,
    'Job Switcher': 0.026,
    Overall: 0.022
  },
  {
    Date: '12/1/13',
    'Job Stayer': 0.02,
    'Job Switcher': 0.026,
    Overall: 0.022
  },
  { Date: '1/1/14', 'Job Stayer': 0.02, 'Job Switcher': 0.027, Overall: 0.022 },
  { Date: '2/1/14', 'Job Stayer': 0.02, 'Job Switcher': 0.027, Overall: 0.023 },
  { Date: '3/1/14', 'Job Stayer': 0.02, 'Job Switcher': 0.027, Overall: 0.023 },
  {
    Date: '4/1/14',
    'Job Stayer': 0.021,
    'Job Switcher': 0.026,
    Overall: 0.023
  },
  {
    Date: '5/1/14',
    'Job Stayer': 0.021,
    'Job Switcher': 0.026,
    Overall: 0.023
  },
  {
    Date: '6/1/14',
    'Job Stayer': 0.021,
    'Job Switcher': 0.027,
    Overall: 0.023
  },
  {
    Date: '7/1/14',
    'Job Stayer': 0.021,
    'Job Switcher': 0.026,
    Overall: 0.023
  },
  {
    Date: '8/1/14',
    'Job Stayer': 0.021,
    'Job Switcher': 0.026,
    Overall: 0.023
  },
  {
    Date: '9/1/14',
    'Job Stayer': 0.022,
    'Job Switcher': 0.027,
    Overall: 0.024
  },
  {
    Date: '10/1/14',
    'Job Stayer': 0.023,
    'Job Switcher': 0.028,
    Overall: 0.025
  },
  {
    Date: '11/1/14',
    'Job Stayer': 0.024,
    'Job Switcher': 0.028,
    Overall: 0.025
  },
  {
    Date: '12/1/14',
    'Job Stayer': 0.024,
    'Job Switcher': 0.028,
    Overall: 0.026
  },
  {
    Date: '1/1/15',
    'Job Stayer': 0.025,
    'Job Switcher': 0.029,
    Overall: 0.026
  },
  {
    Date: '2/1/15',
    'Job Stayer': 0.026,
    'Job Switcher': 0.028,
    Overall: 0.027
  },
  { Date: '3/1/15', 'Job Stayer': 0.026, 'Job Switcher': 0.03, Overall: 0.028 },
  {
    Date: '4/1/15',
    'Job Stayer': 0.027,
    'Job Switcher': 0.031,
    Overall: 0.029
  },
  {
    Date: '5/1/15',
    'Job Stayer': 0.028,
    'Job Switcher': 0.031,
    Overall: 0.029
  },
  { Date: '6/1/15', 'Job Stayer': 0.028, 'Job Switcher': 0.032, Overall: 0.03 },
  {
    Date: '7/1/15',
    'Job Stayer': 0.029,
    'Job Switcher': 0.033,
    Overall: 0.031
  },
  {
    Date: '8/1/15',
    'Job Stayer': 0.029,
    'Job Switcher': 0.033,
    Overall: 0.031
  },
  {
    Date: '9/1/15',
    'Job Stayer': 0.029,
    'Job Switcher': 0.033,
    Overall: 0.031
  },
  {
    Date: '10/1/15',
    'Job Stayer': 0.028,
    'Job Switcher': 0.034,
    Overall: 0.031
  },
  {
    Date: '11/1/15',
    'Job Stayer': 0.029,
    'Job Switcher': 0.035,
    Overall: 0.031
  },
  {
    Date: '12/1/15',
    'Job Stayer': 0.029,
    'Job Switcher': 0.035,
    Overall: 0.031
  },
  {
    Date: '1/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.035,
    Overall: 0.031
  },
  {
    Date: '2/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.036,
    Overall: 0.032
  },
  {
    Date: '3/1/16',
    'Job Stayer': 0.028,
    'Job Switcher': 0.036,
    Overall: 0.031
  },
  {
    Date: '4/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.036,
    Overall: 0.031
  },
  {
    Date: '5/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.038,
    Overall: 0.032
  },
  {
    Date: '6/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.038,
    Overall: 0.032
  },
  {
    Date: '7/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.038,
    Overall: 0.032
  },
  {
    Date: '8/1/16',
    'Job Stayer': 0.029,
    'Job Switcher': 0.039,
    Overall: 0.033
  },
  { Date: '9/1/16', 'Job Stayer': 0.03, 'Job Switcher': 0.04, Overall: 0.034 },
  {
    Date: '10/1/16',
    'Job Stayer': 0.032,
    'Job Switcher': 0.04,
    Overall: 0.035
  },
  {
    Date: '11/1/16',
    'Job Stayer': 0.032,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  {
    Date: '12/1/16',
    'Job Stayer': 0.032,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  {
    Date: '1/1/17',
    'Job Stayer': 0.032,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  { Date: '2/1/17', 'Job Stayer': 0.032, 'Job Switcher': 0.04, Overall: 0.035 },
  {
    Date: '3/1/17',
    'Job Stayer': 0.032,
    'Job Switcher': 0.042,
    Overall: 0.035
  },
  {
    Date: '4/1/17',
    'Job Stayer': 0.031,
    'Job Switcher': 0.042,
    Overall: 0.035
  },
  { Date: '5/1/17', 'Job Stayer': 0.031, 'Job Switcher': 0.04, Overall: 0.035 },
  { Date: '6/1/17', 'Job Stayer': 0.031, 'Job Switcher': 0.04, Overall: 0.034 },
  {
    Date: '7/1/17',
    'Job Stayer': 0.031,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  { Date: '8/1/17', 'Job Stayer': 0.03, 'Job Switcher': 0.041, Overall: 0.035 },
  { Date: '9/1/17', 'Job Stayer': 0.03, 'Job Switcher': 0.04, Overall: 0.034 },
  {
    Date: '10/1/17',
    'Job Stayer': 0.029,
    'Job Switcher': 0.04,
    Overall: 0.033
  },
  {
    Date: '11/1/17',
    'Job Stayer': 0.028,
    'Job Switcher': 0.04,
    Overall: 0.033
  },
  {
    Date: '12/1/17',
    'Job Stayer': 0.028,
    'Job Switcher': 0.04,
    Overall: 0.033
  },
  { Date: '1/1/18', 'Job Stayer': 0.028, 'Job Switcher': 0.04, Overall: 0.033 },
  { Date: '2/1/18', 'Job Stayer': 0.027, 'Job Switcher': 0.04, Overall: 0.032 },
  { Date: '3/1/18', 'Job Stayer': 0.028, 'Job Switcher': 0.04, Overall: 0.033 },
  { Date: '4/1/18', 'Job Stayer': 0.028, 'Job Switcher': 0.04, Overall: 0.032 },
  { Date: '5/1/18', 'Job Stayer': 0.027, 'Job Switcher': 0.04, Overall: 0.032 },
  { Date: '6/1/18', 'Job Stayer': 0.028, 'Job Switcher': 0.04, Overall: 0.033 },
  {
    Date: '7/1/18',
    'Job Stayer': 0.028,
    'Job Switcher': 0.039,
    Overall: 0.032
  },
  {
    Date: '8/1/18',
    'Job Stayer': 0.029,
    'Job Switcher': 0.038,
    Overall: 0.032
  },
  {
    Date: '9/1/18',
    'Job Stayer': 0.029,
    'Job Switcher': 0.037,
    Overall: 0.032
  },
  {
    Date: '10/1/18',
    'Job Stayer': 0.03,
    'Job Switcher': 0.038,
    Overall: 0.033
  },
  {
    Date: '11/1/18',
    'Job Stayer': 0.031,
    'Job Switcher': 0.038,
    Overall: 0.034
  },
  {
    Date: '12/1/18',
    'Job Stayer': 0.032,
    'Job Switcher': 0.039,
    Overall: 0.035
  },
  {
    Date: '1/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.039,
    Overall: 0.035
  },
  {
    Date: '2/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.039,
    Overall: 0.035
  },
  {
    Date: '3/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.038,
    Overall: 0.035
  },
  {
    Date: '4/1/19',
    'Job Stayer': 0.034,
    'Job Switcher': 0.039,
    Overall: 0.036
  },
  {
    Date: '5/1/19',
    'Job Stayer': 0.034,
    'Job Switcher': 0.039,
    Overall: 0.036
  },
  { Date: '6/1/19', 'Job Stayer': 0.035, 'Job Switcher': 0.04, Overall: 0.037 },
  {
    Date: '7/1/19',
    'Job Stayer': 0.034,
    'Job Switcher': 0.041,
    Overall: 0.037
  },
  {
    Date: '8/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.042,
    Overall: 0.037
  },
  {
    Date: '9/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '10/1/19',
    'Job Stayer': 0.033,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '11/1/19',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '12/1/19',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '1/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '2/1/20',
    'Job Stayer': 0.033,
    'Job Switcher': 0.044,
    Overall: 0.037
  },
  {
    Date: '3/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '4/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '5/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.044,
    Overall: 0.037
  },
  {
    Date: '6/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '7/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '8/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.042,
    Overall: 0.036
  },
  {
    Date: '9/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.042,
    Overall: 0.036
  },
  {
    Date: '10/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.042,
    Overall: 0.036
  },
  {
    Date: '11/1/20',
    'Job Stayer': 0.032,
    'Job Switcher': 0.042,
    Overall: 0.036
  },
  {
    Date: '12/1/20',
    'Job Stayer': 0.031,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  {
    Date: '1/1/21',
    'Job Stayer': 0.031,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  {
    Date: '2/1/21',
    'Job Stayer': 0.031,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  { Date: '3/1/21', 'Job Stayer': 0.032, 'Job Switcher': 0.04, Overall: 0.035 },
  { Date: '4/1/21', 'Job Stayer': 0.032, 'Job Switcher': 0.04, Overall: 0.035 },
  {
    Date: '5/1/21',
    'Job Stayer': 0.031,
    'Job Switcher': 0.039,
    Overall: 0.034
  },
  {
    Date: '6/1/21',
    'Job Stayer': 0.031,
    'Job Switcher': 0.038,
    Overall: 0.034
  },
  { Date: '7/1/21', 'Job Stayer': 0.031, 'Job Switcher': 0.04, Overall: 0.035 },
  {
    Date: '8/1/21',
    'Job Stayer': 0.031,
    'Job Switcher': 0.041,
    Overall: 0.035
  },
  {
    Date: '9/1/21',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '10/1/21',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.036
  },
  {
    Date: '11/1/21',
    'Job Stayer': 0.032,
    'Job Switcher': 0.043,
    Overall: 0.037
  },
  {
    Date: '12/1/21',
    'Job Stayer': 0.034,
    'Job Switcher': 0.046,
    Overall: 0.038
  },
  //NOTE: This data is only being shown quarterly as client wanted less precise line.
  // (see line 22 ins Wages.js -- function is taking every fourth item.)
  //In order to make this last data point show, I'm duplicating it so it will be a fourth item.
  //On future data updates, this can be taken out.
  {
    Date: '12/1/21',
    'Job Stayer': 0.034,
    'Job Switcher': 0.046,
    Overall: 0.038
  }
]
